import { useEffect } from "react";

/**
 * Sets document.title for the route it wraps, e.g.
 *   <RouteTitle title="FAQs | Healing Hues"><FAQ /></RouteTitle>
 */
export default function RouteTitle({ title, children }) {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return children;
}
